import { selectModeName } from "@/store/mode-selectors";
import {
  useAppDispatch,
  useAppSelector,
  useAppStore,
} from "@/store/store-hooks";
import { changeMode } from "@/store/mode-slice";
import { selectActiveTool } from "@/store/ui/ui-selectors";
import { ToolName } from "@/store/ui/ui-slice";
import { useMediaQuery } from "@mui/material";
import { useLayoutEffect } from "react";

export const PHONE_VIEWPORT_QUERY =
  "(max-width: 599.95px), (pointer: coarse) and (hover: none) and (orientation: landscape) and (max-height: 599.95px)";

/** @returns Whether the viewport needs phone-sized controls. */
export function usePhoneViewport(): boolean {
  return useMediaQuery(PHONE_VIEWPORT_QUERY);
}

/** @returns Whether the current viewer supports the compact phone layout. */
export function usePhoneViewerLayout(): boolean {
  const isPhone = usePhoneViewport();
  const mode = useAppSelector(selectModeName);
  const activeTool = useAppSelector(selectActiveTool);
  return (
    isPhone &&
    (mode === "walk" || mode === "sheet" || mode === "overview") &&
    activeTool !== ToolName.createPDFReport &&
    activeTool !== ToolName.createSnapshot
  );
}

/** @returns Whether unsupported split UI is being replaced with its primary Walk view. */
export function usePhoneSingleView(): boolean {
  const isPhone = usePhoneViewport();
  const mode = useAppSelector(selectModeName);
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const isNormalizing = isPhone && mode === "split";
  useLayoutEffect(() => {
    if (isNormalizing) {
      dispatch(
        changeMode({
          mode: "walk",
          initialState: store.getState().mode.initialState,
        }),
      );
    }
  }, [dispatch, isNormalizing, store]);
  return isNormalizing;
}
